import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaBrfSys.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(CAT|BRFSYS)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            const data = map.root.data;

            return ['DRAFT', 'PRE_APPROVAL_REJECTED', 'ACCESS_APPROVAL_REJECTED'].includes(data.brfStsCode) ? [
                {type: 'CAT'},
            ] : []
        },

        menuItemsInsertConcept(map, node) {
            const data = map.root.data;

            return ['DRAFT', 'PRE_APPROVAL_REJECTED', 'ACCESS_APPROVAL_REJECTED'].includes(data.brfStsCode) ? [
                {type: 'BRFSYS'},
            ] : []
        },
    })
}
